import { api } from '@/lib/api'

/**
 * @returns {Promise<{ branches: Array<{ slug: string, name: string, address?: string, hero_image_url?: string, hero_subline?: string, theme_secondary?: string }> }>}
 */
export async function fetchBookingHub() {
  const { data } = await api.get('/public/booking')
  return data.data
}

/**
 * @param {string} slug
 */
export async function fetchBookingConfig(slug) {
  const { data } = await api.get(`/public/booking/${slug}/config`)
  return data.data
}

/**
 * @param {string} slug
 * @param {{ date: string, serviceIds: number[] }} params
 */
export async function fetchBookingSlots(slug, { date, serviceIds, stylistId = null }) {
  const { data } = await api.get(`/public/booking/${slug}/slots`, {
    params: {
      date,
      service_ids: serviceIds,
      ...(stylistId ? { stylist_id: stylistId } : {}),
    },
  })
  return data.data.slots
}

/**
 * @param {string} slug
 * @param {{ phone: string }} payload
 */
export async function sendBookingOtp(slug, payload) {
  const { data } = await api.post(`/public/booking/${slug}/otp/send`, payload)
  return data
}

/**
 * @param {string} slug
 * @param {{ phone: string, code: string }} payload
 */
export async function verifyBookingOtp(slug, payload) {
  const { data } = await api.post(`/public/booking/${slug}/otp/verify`, payload)
  return data
}

/**
 * @param {string} slug
 * @param {{
 *   name: string,
 *   phone: string,
 *   starts_at: string,
 *   service_ids: number[],
 *   stylist_id?: number | null,
 *   gender?: 'ladies' | 'gents',
 *   notes?: string,
 *   otp_verification_token?: string,
 * }} payload
 */
export async function createPublicBooking(slug, payload) {
  const { data } = await api.post(`/public/booking/${slug}/appointments`, payload)
  return data
}

/**
 * @param {'pending' | 'confirmed' | 'all'} filter
 */
export async function fetchOnlineBookingQueue(filter = 'pending') {
  const { data } = await api.get('/online-booking/queue', { params: { filter } })
  return data.data
}

/**
 * Lightweight poll for nav badge / notifications.
 */
export async function fetchOnlineBookingInboxSummary() {
  const { data } = await api.get('/online-booking/inbox-summary')
  return data.data
}

/**
 * Staff — share links for active branch (all authenticated roles).
 */
export async function fetchOnlineBookingShare() {
  const { data } = await api.get('/online-booking/share')
  return data.data
}

/**
 * @returns {Promise<import('@/types/api').Appointment[]>}
 */
export async function fetchPendingOnlineBookings() {
  const { data } = await api.get('/online-booking/pending')
  return data.data.appointments
}

/**
 * @param {string} token
 */
export async function fetchPublicBookingManage(token) {
  const { data } = await api.get(`/public/booking/manage/${token}`)
  return data.data
}

/**
 * @param {string} token
 */
export async function cancelPublicBooking(token) {
  const { data } = await api.post(`/public/booking/manage/${token}/cancel`)
  return data
}

/**
 * @param {string} token
 * @param {{ starts_at: string }} payload
 */
export async function reschedulePublicBooking(token, payload) {
  const { data } = await api.post(`/public/booking/manage/${token}/reschedule`, payload)
  return data
}
